export const formatCurrency = (amount: number, fractionDigits = 0): string => {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(amount);
};

export const formatWithCommas = (value: string, forceTwoDecimals = false) => {
  const raw = value.replace(/,/g, '');
  if (!raw) return '';
  const [whole = '', decimalPart] = raw.split('.');
  const formattedWhole = Number(whole || '0').toLocaleString('en-US');
  if (forceTwoDecimals) {
    const amount = Number(raw);
    if (!Number.isFinite(amount)) return value;
    const [w, d = '00'] = amount.toFixed(2).split('.');
    return `${Number(w).toLocaleString('en-US')}.${d}`;
  }
  if (decimalPart !== undefined) {
    return `${formattedWhole}.${decimalPart.slice(0, 2)}`;
  }
  return formattedWhole;
};

export const formatKilometers = (kms: number): string => {
  return new Intl.NumberFormat('en-AU').format(kms) + ' km';
};

export const formatName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string => {
  const first = firstName?.trim() || '';
  const last = lastName?.trim() || '';

  if (!first && !last) return '';
  if (!last) return first;
  if (!first) return last;

  return `${first} ${last}`.trim();
};
